// Test IDs for Captec public pages and shared components.
// Naming convention: <feature>-<element>, kebab-case.

export const NAV = {
  logo: "nav-logo",
  link: (slug) => `nav-link-${slug}`,
  ctaContacto: "nav-cta-contacto",
  mobileToggle: "nav-mobile-toggle",
  mobileDrawer: "nav-mobile-drawer",
  mobileLink: (slug) => `nav-mobile-link-${slug}`,
};

export const FOOTER = {
  root: "footer-root",
  mapsIframe: "footer-maps-iframe",
  navLink: (slug) => `footer-nav-link-${slug}`,
};

export const HOMEPAGE = {
  root: "home-empty-main",
};

export const NOSOTROS = {
  root: "page-nosotros",
  trustBand: "nosotros-trust-band",
  missionCard: "nosotros-mission-card",
  visionCard: "nosotros-vision-card",
  leaderCard: (slug) => `nosotros-leader-${slug}`,
  leaderVideoBtn: (slug) => `nosotros-leader-video-${slug}`,
  videoModal: "nosotros-video-modal",
  videoModalClose: "nosotros-video-modal-close",
  valueCard: (slug) => `nosotros-value-${slug}`,
};

export const SERVICIOS = {
  root: "page-servicios",
  techMap: "servicios-tech-map",
  techMapNode: (slug) => `servicios-tech-node-${slug}`,
  serviceCard: (slug) => `servicios-card-${slug}`,
  metric: (slug) => `servicios-metric-${slug}`,
  certificationsList: "servicios-certifications",
};

export const NOTICIAS = {
  root: "page-noticias",
  filterAll: "noticias-filter-all",
  filter: (slug) => `noticias-filter-${slug}`,
  featured: "noticias-featured",
  card: (slug) => `noticias-card-${slug}`,
  interviewSection: "noticias-interview-section",
};

export const CONTACTO = {
  root: "page-contacto",
  techCard: "contacto-tech-card",
  commercialCard: "contacto-commercial-card",
  addressCard: "contacto-address-card",
  form: "contacto-form",
  formName: "contacto-form-name",
  formEmail: "contacto-form-email",
  formPhone: "contacto-form-phone",
  formCompany: "contacto-form-company",
  formService: "contacto-form-service",
  formMessage: "contacto-form-message",
  formSubmit: "contacto-form-submit",
  mapsIframe: "contacto-maps-iframe",
};

export const POLITICA = {
  root: "page-politica",
};

export const SCROLL_TOP = {
  button: "scroll-to-top",
};
